export default __webpack_public_path__ + "static/media/marker-blue-orange.5ca1918a.png";